import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TableBase from './TableBase.vue'
import TextBase, { TextType } from './TextBase.vue'
import { computed } from 'vue'

export type BasicTable = {
  headers?: { text: string; isLoading?: boolean; textAlign?: 'left' | 'center' | 'right' }[]
  rows: { text: string; isLoading?: boolean; textAlign?: 'left' | 'center' | 'right' }[][]
}

type Props = {
  caption: string
  textTypeHeader?: TextType
  textTypeCell?: TextType
  sortBy?: (i: number) => string | number
  direction?: 'asc' | 'desc'
  table: BasicTable
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableBasicTextLoader',
  props: {
    caption: {},
    textTypeHeader: { default: 'tiny' },
    textTypeCell: { default: 'tiny' },
    sortBy: { type: Function, default: undefined },
    direction: { default: 'asc' },
    table: {}
  },
  setup(__props: any) {

const props = __props

const table = computed(() => ({
  headers: {
    top: props.table.headers?.map((header) => ({
      text: header.text,
      isLoading: header.isLoading,
      style: {
        textAlign: header.textAlign ?? 'left'
      }
    }))
  },
  body: props.table.rows.map((row) =>
    row.map((cell) => ({
      text: cell.text,
      style: {
        textAlign: cell.textAlign ?? 'left'
      },
      isLoading: cell.isLoading
    }))
  )
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableBase, {
    table: table.value,
    caption: _ctx.caption,
    sortBy: _ctx.sortBy,
    sortDirection: _ctx.direction,
    layout: "fixed"
  }, {
    "header-cell": _withCtx(({ cell }) => [
      (!cell.isLoading)
        ? (_openBlock(), _createBlock(TextBase, {
            key: 0,
            text: cell.text,
            type: _ctx.textTypeHeader,
            weight: "bold"
          }, null, 8, ["text", "type"]))
        : (_openBlock(), _createBlock(PulseLoader, {
            key: 1,
            loading: true,
            color: "#3F46D6",
            size: "8px"
          }))
    ]),
    "body-cell": _withCtx(({ cell }) => [
      (!cell.isLoading)
        ? (_openBlock(), _createBlock(TextBase, {
            key: 0,
            text: cell.text,
            type: _ctx.textTypeCell
          }, null, 8, ["text", "type"]))
        : (_openBlock(), _createBlock(PulseLoader, {
            key: 1,
            loading: true,
            color: "#3F46D6",
            size: "6px"
          }))
    ]),
    _: 1
  }, 8, ["table", "caption", "sortBy", "sortDirection"]))
}
}

})